import React from "react";
import { TspCard } from "../../../components/primitives";
import useCityVisitForm from "../useCityVisitForm";
import CityVisitFormFields from "./CityVisitFormFields";

// "Add City Visit" on the City Visits screen. The journey and its cities come
// from the server; the form's state and rules live in useCityVisitForm (shared
// with the journey page's "Visit Now" dialog).
//
// Opened from a "Visit Now" link (`initialLocationId` + `locked`): the journey
// and the stop arrive selected and stay fixed.
export default function CityVisitFormCard({ journeys, journeyId, onJourneyChange, cities, citiesLoading, onSubmit, initialLocationId = "", locked = false }) {
  const form = useCityVisitForm({ journeys, journeyId, onJourneyChange, cities, onSubmit, initialLocationId });

  return (
    <TspCard title="Add City Visit">
      <CityVisitFormFields form={form} journeys={journeys} journeyId={journeyId} cities={cities} citiesLoading={citiesLoading} locked={locked} />
      <button type="button" className="tsp-btn tsp-btn-success" style={{ marginTop: 14 }} onClick={form.handleSubmit} disabled={form.saving || !form.requiredFilled}>
        {form.saving ? "Saving…" : "Add Visit"}
      </button>
    </TspCard>
  );
}
